// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__292Ai","addWidgetButton":"Header_addWidgetButton__3Lh9d","dashboardTabs":"Header_dashboardTabs__2XA3P","active":"Header_active__26WTS"};